import { z } from 'zod';

const emptyMessageError = 'Message must contain at least 1 character, not including space';

const validationSchema = z
  .object({
    message: z.string(),
    file: z.instanceof(Blob).optional().nullable(),
  })
  .superRefine((data, ctx) => {
    const hasFile = data.file instanceof Blob;
    if (hasFile) {
      return;
    }
    if (data.message.trim().length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: emptyMessageError,
        path: ['message'],
      });
    }
  });

export default validationSchema;
